import axiosClient from './axiosClient';
import { serviceBase } from './serviceBase';

export const getUpfrontRents = serviceBase({
  request: options =>
    axiosClient.get('/upfront-rents', {
      params: options,
    }),
  retry: 0
});

export const downloadUpfrontRents = serviceBase({
  request: options =>
    axiosClient.get('/upfront-rents/export', {
      responseType: 'blob',
      params: options,
      timeout: 120000
    }),
  transformResponse: res => {
    try {
      const filename = 'Rentas anticipadas.xlsx';
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(res.data);
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
    } catch (error) {
      console.log(`Opps, un error: ${error}`);
      console.error(error);
    }
  },
  retry: 0
});
